export interface FitSkillEmployeeExpirationDto {
  HrRef: number;
  SkillCertificationDate: Date | null;
  SkillExpireDate: Date | null;
  FitCertificationDate: Date | null;
  FitExpireDate: Date | null;
  SkillKeyId: number | null;
  FitKeyId: number | null;
  EmployeeId: string | null;
  DispatchStatusName: string;
  DispatchStatusID: number;
  VpJobId: string;
  VpJobCompanyId: number | null;
  JobCompanyId: string | null;
  JobId: string;
  Shift: number | null;
  EmDesignationName: string;
  EmDesignationID: number | null;
  EndDateExpected: Date | null;
  EmployeeFullName: string;
  SSN: string;
  IsFitExpired: boolean;
  IsSkillExpired: boolean;
  IsFitExpirationUpcoming: boolean;
  IsSkillExpirationUpcoming: boolean;
  FitTestIsMissing: boolean;
  SkillTestIsMissing: boolean;
}
